import React from 'react'
import PropTypes from 'prop-types'

function InfoItem({ info }) {

  //return  
  return (
    <div className="info-item">
      <div className="info-item_icon-wrapper">
        {info.icon}
      </div>

      <div className="info-item_text-wrapper">
        <p className="info-item_value">
          {info.value}
        </p>

        <p className="info-item_title">
          {info.title}
        </p>
      </div>
    </div>
  )
}

InfoItem.propTypes = {
  info: PropTypes.object.isRequired,
}

export default InfoItem